import { CARD_TYPES } from '../../constants/CardTypes';

export const getCardType = backEndType => {
  switch (backEndType) {
    case 'HOLIDAY':
      return CARD_TYPES.holiday;
    case 'THANK_YOU':
      return CARD_TYPES.thankyou;
    case 'SAVE_THE_DATE':
      return CARD_TYPES.std;
    case 'CHANGE_THE_DATE':
      return CARD_TYPES.ctd;
    case 'INVITATION':
      return CARD_TYPES.invitation;
    case 'DETAILS':
      return CARD_TYPES.enclosure;
    case 'MENU':
      return CARD_TYPES.menu;
    case 'PROGRAM':
      return CARD_TYPES.program;
    case 'PLACE_CARDS':
      return CARD_TYPES.placecards;
    default:
      return 'STANDARD';
  }
};



// WEBPACK FOOTER //
// ./src/cards/reducers/pdp/utils.js